// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../css';
import { StyledCardTag } from './CardTag.styles';

export const FEATURE_COLOR = ['primary', 'secondary', 'tertiary'];
export const FEATURE_COLORS = {
  primary: colors.colorBlue,
  secondary: colors.colorCobalt,
  tertiary: colors.colorBurgundy
};

/**
 *
 * Regular CardTag component to be included on Cards.
 */

function CardTag({ children, color }) {
  return (
    <StyledCardTag className="card-tag" color={FEATURE_COLORS[color]}>
      {children}
    </StyledCardTag>
  );
}

CardTag.propTypes = {
  /** Copy inside feature tag */
  children: PropTypes.string.isRequired,
  /** Color of the feature tag */
  color: PropTypes.oneOf(FEATURE_COLOR)
};

CardTag.defaultProps = {
  color: 'primary'
};

export default CardTag;
